// export const apiEndPoint = "http://192.168.1.17:8000"
export const apiEndPoint = "https://beeatneb.in:8443"